module.exports = __webpack_public_path__ + "assets/facbe62f0a2f373585091c6a14fb5327.png";